import Link from "next/link"

import { Button } from "@coval/ui"
import { History, Link2, Pencil, TextCursorInput } from "lucide-react"

import { reportNotebookExport } from "../../utils/notebookExport"
import type { Notebook } from "../../utils/reportTypes"
import { NotebookDownloadButton } from "../NotebookDownloadButton"
import { NotebookShareButton } from "../NotebookShareButton"
import { reportClass } from "./ReportStyles"

export function ReportToolbarActions({
  notebook,
  organizationSlug,
  workspaceId,
  locked,
  preview,
  readonly,
  sharingEnabled,
  onExporting,
  onHistory,
  onRename,
  latestHref,
  onShare,
}: {
  notebook: Notebook
  organizationSlug: string
  workspaceId: string
  locked: boolean
  preview: boolean
  readonly: boolean
  sharingEnabled: boolean
  onExporting: (busy: boolean) => void
  onHistory: () => void
  onRename: () => void
  /** On a pinned revision link, where the latest revision lives. */
  latestHref?: string
  onShare: () => void
}) {
  return (
    <div className={reportClass("toolbar-actions")}>
      <NotebookDownloadButton
        key={`${organizationSlug}:${workspaceId}:${notebook.id}`}
        notebook={reportNotebookExport(notebook)}
        organizationSlug={organizationSlug}
        workspaceId={workspaceId}
        disabled={locked}
        onBusyChange={onExporting}
      />
      {latestHref && (
        <Button asChild variant="secondary">
          <Link href={latestHref}>
            <Pencil />
            Open latest
          </Link>
        </Button>
      )}
      <Button variant="ghost" disabled={locked} onClick={onHistory}>
        <History />
        History
      </Button>
      {!preview && !readonly && (
        <Button variant="ghost" disabled={locked} onClick={onRename}>
          <TextCursorInput />
          Rename
        </Button>
      )}
      {sharingEnabled && (
        <>
          <NotebookShareButton
            key={`share:${organizationSlug}:${workspaceId}:${notebook.id}`}
            notebookId={notebook.id}
            organizationSlug={organizationSlug}
            workspaceId={workspaceId}
            targetKind="generated"
            audience={notebook.audience}
          />
          <Button variant="secondary" disabled={locked} onClick={onShare}>
            <Link2 />
            Copy revision link
          </Button>
        </>
      )}
    </div>
  )
}
